import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVoiceLow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="voice-low, wave"><path d="M7.75 6.75V17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 11.25V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 10.75V13.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.25 8.75V15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 11.25V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVoiceLow;
